
import React, { Component, Fragment  } from 'react';
import './EstadoActivo.css'; 
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import MyButton from '../../../utils/MyButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

import CircularProgress from '@material-ui/core/CircularProgress';

import { FaArrowLeft,FaPlus, FaLaptopMedical, FaCheckCircle, FaCheck } from "react-icons/fa";

import {cambiarEstadoActivo,clearErrors,getActivo} from '../../../redux/actions/mobiliarioactions';

export class EstadoActivo extends Component {
    constructor(){
        super();
        this.state={
            estado:'',
            nuevoestado:'',
            errors:{},
            open:false,
            aprobado:{}
        };
        
    };
    static getDerivedStateFromProps(props, state) {
        const newState = {};
    
        if (props.UI.errors) {
            newState.errors = props.UI.errors;
        }
    
        if (props.UI.aprobado) {
           newState.aprobado = props.UI.aprobado;
        }
    
        return Object.keys(newState).length > 0 ? newState : null;
    }

    mapUserDetailsToState = (mobiliario) => {
        this.setState({
            estado:mobiliario.estado?mobiliario.estado:'',
            nuevoestado:mobiliario.estado?mobiliario.estado:''
        });
      };

      handleOpen = () => {
        this.setState({ open: true,aprobado:{} });
        this.mapUserDetailsToState(this.props.mobiliario);
      };

      handleClose=()=>{


        if(this.state.aprobado.mensaje){
            //getEquipos this.handleEditProgMto();
            this.props.getActivo(this.props.mobiliarioId);
            this.setState({
                
                open:false,errors:{},aprobado:{}});
        }else{
            this.setState({
                
                open:false,errors:{},aprobado:{}});
        }
       
       
                    
        };
      handleChange = (event) => {
        this.setState({
          [event.target.name]: event.target.value
        });
      };
    
      handleSubmit = (event) => {
       console.log(this.props.mobiliarioId);
       console.log(this.state.nuevoestado);
        this.props.cambiarEstadoActivo(this.props.mobiliarioId,this.state.nuevoestado);
        
      };
  render() {
    const { UI:{loading}}=this.props; 
    const {errors}=this.state;
    return (
        <div>
        <Fragment>
    <MyButton tip="Cambiar Estado Activo" onClick={this.handleOpen}>
    <FaLaptopMedical color="#03178C" className="icon-crearcliente"/>
     </MyButton>

     <Dialog
     open={this.state.open}
     onClose={this.handleClose}
     fullWidth
     maxWidth="sm"
    >
        {this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-aprobado'>
                    <FaCheck color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Estado Actualizado Exitosamente</h2>
                  
                 
              </div>
                
                ) : (<div>
 <DialogTitle>Cambiar Estado del Activo</DialogTitle>
       
       <DialogContent>
               <form>
               
               
                 
                 
                 <div className="input_divido_children">
                 <FormControl className="formcontrol-nuevocliente" error={errors.nuevoestado?true:false}>
                               <InputLabel> Nuevo Estado</InputLabel>
                               <Select
                               required
                            name="nuevoestado"
                            id="nuevoestado"
                            value={this.state.nuevoestado}
                               onChange={this.handleChange}
                               fullWidth
                               >
                               <MenuItem value="">
                                   <em></em>
                               </MenuItem>
                               <MenuItem value="Funcionando">Funcionando</MenuItem>
                                <MenuItem value="Correctivo">Correctivo</MenuItem>
                                <MenuItem value="De Baja">De Baja</MenuItem>
                               </Select>
                               <FormHelperText>{errors.nuevoestado}</FormHelperText>
                           </FormControl>
                   </div>
                   
   
   
   
   
                 </form>
                 
       
       </DialogContent>
                </div>)}
   
                <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>

             {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                              
                  <MyButton tip="Cerrar" onClick={this.handleClose}>
                    <FaCheckCircle color="#20B90C" className="icon-formulario" />
                  </MyButton>
                  
                ) : (
                  <MyButton tip="Actualizar" onClick={this.handleSubmit}>
                    <FaPlus color="#03178C" className="icon-formulario" />
                  </MyButton>
                )
              )}
            
            
          </DialogActions>

    </Dialog>
     </Fragment>

    </div>
    )
  }
}

EstadoActivo.propTypes = {
    cambiarEstadoActivo: PropTypes.func.isRequired,
    getActivo:PropTypes.func.isRequired,
  
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired  
  };

  const mapActionsToProps={cambiarEstadoActivo,getActivo,clearErrors};

  const mapStateToProps = (state) => ({
    mobiliario: state.dataMob.mobiliario.credentials,
    UI:state.UI
  });
  
  export default connect(mapStateToProps,mapActionsToProps)(EstadoActivo);


